//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PageLoader from '@motionelements/core/src/components/ui/PageLoader.vue';
import mapId from '@/components/legal/mapId.js';

import * as documentsApi from '@motionelements/core/src/api/agreements.js';

export default {
  name: 'LegalPage',
  layout: 'legal',
  async asyncData({ params, redirect, app }) {
    if (params.document) {
      const documentId = mapId.convert(params.document);
      return { documentId };
    }

    redirect(app.$link('/legal/license').fullPath());
  },
  components: {
    LegalDocument: () => import('@/components/legal/LegalDocument.vue'),
    PageLoader,
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
  },
  data() {
    return {
      document: null,
      isDocumentLoading: false,
    };
  },
  async fetch() {
    return this.getDocumentById();
  },
  methods: {
    async getDocumentById() {
      this.isDocumentLoading = true;
      return documentsApi.getAgreement(this.documentId)
        .then(({ data: { data } }) => {
          if (_.get(data, 'id')) {
            this.document = data;
          } else {
            this.$router.push(this.$link('/legal/license').fullPath());
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.isDocumentLoading = false;
        });
    },
  },
  mounted() {
    if (!this.document && !this.isDocumentLoading) {
      this.getDocumentById();
    }
  },
  computed: {
    description() {
      if (_.get(this.document, 'body')) {
        const startIndex = this.document.body.indexOf('<p');
        const endIndex = this.document.body.indexOf('</p>', startIndex);
        const paragraphContent = this.document.body.substring(startIndex, endIndex);
        const paragraphContentTrim = paragraphContent
          .replace(/<\/?[^>]+(>|$)/g, '')
          .trim();
        if (paragraphContentTrim.length > 160) {
          return `${paragraphContentTrim.substring(0, 157)}...`;
        }
        return paragraphContentTrim;
      }
      return null;
    },
    breadcrumbList() {
      return [
        {
          name: _.get(this.document, 'title'),
          link: this.$link(_.get(this.document, 'html.url')).fullPath(),
          active: true,
        },
      ];
    },
  },
};
